import clsx from 'clsx'
import includes from 'lodash/includes'
import React, { useEffect, useState } from 'react'
import { toast, Toaster } from 'sonner'

import SvgClose from '@Assets/SVG/Close'
import { BarFactory } from '@Components/CMS/Bars/Factory'
import { useDiscountCodes } from '@Domains/Cart/Feature/DiscountCodes'
import { SplitTestGroup } from '@Generated/graphql'
import { Bar } from '@Globals/Metadata'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { Test } from '@Globals/SplitTests/types'
import { useTranslation } from '@Globals/Translations'

import styles from './styles.module.scss'

const getBarComponents = (bar) => {
  if (!includes(bar.placement, 'extended_coupon')) {
    return null
  }

  const barComponent = (
    <BarFactory
      key={bar.id}
            // TODO: use BarContentFragment for bars
      bar={bar as Bar}
      id={`bar-extended_coupon-${bar.id}`}
      order={bar.priority}
      placement="extended_coupon"
    />
  )

  if (bar?.splitTest?.test) {
    return (
      <Experiment
        key={bar.id}
        a={includes(bar?.splitTest.groups, SplitTestGroup.A) ? barComponent : undefined}
        b={includes(bar?.splitTest.groups, SplitTestGroup.B) ? barComponent : undefined}
        c={includes(bar?.splitTest.groups, SplitTestGroup.C) ? barComponent : undefined}
        d={includes(bar?.splitTest.groups, SplitTestGroup.D) ? barComponent : undefined}
        test={bar?.splitTest.test as Test}
      />
    )
  }
  return barComponent
}

export const CartExtendedCoupons = () => {
  const { t } = useTranslation()
  const { bars } = useDiscountCodes()
  const [length, setLength] = useState(bars.length)
  useEffect(() => {
    toast.dismiss()
    bars.forEach((bar) => {
      toast.custom(bread => (
        <>
          {getBarComponents(bar)}
          <button
            aria-label={t('common:CLOSE')}
            className={styles.closeButton}
            onClick={() => {
              setTimeout(() => setLength(toast.length - 1), 100)
              toast.dismiss(bread)
            }}
            title={t('common:CLOSE')}
            type="button"
          >
            <SvgClose />
          </button>
        </>
      ), {
        duration: Number.POSITIVE_INFINITY,
        className: styles.extendedCoupons,
        position: 'bottom-left',
      })
    })
    setLength(bars.length)
  }, [bars, t])

  if (!bars || bars.length === 0) {
    return null
  }

  return (
    <div className={clsx(styles.cartExtendedCoupons, length === 1 && 'single')} id="CartExtendedCoupons">
      <Toaster className={styles.CartExtendedCouponsTest} />
    </div>
  )
}
